import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { logout } from "./Utility";
import toast from 'react-hot-toast';
import customFetch from './apicall/api';

const LoanNocDownload = () => {
    const history = useHistory();
    const location = useLocation();
    const { api_token } = (location && location.state) || {};
    
    const [loanIdsInput, setLoanIdsInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [validationError, setValidationError] = useState('');

    // Updated validation: accepts comma-separated list (1-10 IDs)
    const validateLoanIds = (value) => {
        if (!value || value.trim() === '') {
            return 'At least one Loan ID is required';
        }
        const ids = value.split(',').map(s => s.trim()).filter(s => s !== '');
        if (ids.length < 1) {
            return 'At least one Loan ID is required';
        }
        if (ids.length > 10) {
            return 'Maximum 10 Loan IDs allowed';
        }
        const loanIdPattern = /^[A-Z]{2}\d{3}[A-Z]{2}\d{6}[A-Z]\d{2}$/;
        for (let id of ids) {
            if (!loanIdPattern.test(id)) {
                return `Invalid Loan ID format: ${id}. Expected format like MP008LE001726N01`;
            }
        }
        return '';
    };

    const handleInputChange = (e) => {
        const value = e.target.value.toUpperCase();
        setLoanIdsInput(value);
        if (validationError) setValidationError('');
    };

    // Function to download a single NOC 
const downloadSingleNOC = async (loanId) => {
    const res = await customFetch(
        `${process.env.REACT_APP_DOWNLOAD}forms/loan_no_dues.php?loan_id=${encodeURIComponent(loanId)}`,
        { method: 'GET', headers: {} }
    );
    const contentType = res.headers.get("Content-Type");
    
    // If response is not PDF
    if (!res.ok || contentType !== "application/pdf") {
        let errorText = "";
        try {
            errorText = await res.text(); // "Please mark loan as closed"
        } catch(e) {}
        // Throw error with loan ID included
        throw new Error(`Loan ${loanId} is not closed. ${errorText}`);
    }
    
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `NOC_${loanId}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
    return true;
};

    const downloadMultipleNOCs = async (loanIds) => {
        for (let i = 0; i < loanIds.length; i++) {
            const id = loanIds[i];
            toast.loading(`Downloading ${id}...`, { id: `noc_${id}` });
            try {
                await downloadSingleNOC(id);
                toast.success(`Downloaded ${id}`, { id: `noc_${id}` });
                // Small delay to avoid browser blocking multiple downloads
                await new Promise(r => setTimeout(r, 800));
            } catch (err) {
                toast.error(err.message, { id: `noc_${id}` });
                // Continue with next loan even if one fails
            }
        }
    };

    const downloadNOC = async () => {
        const error = validateLoanIds(loanIdsInput);
        if (error) {
            setValidationError(error);
            toast.error(error);
            return;
        }

        setLoading(true);
        const loanIds = loanIdsInput.split(',').map(s => s.trim());
        try {
            await downloadMultipleNOCs(loanIds);
        } catch (err) {
            toast.error('Download process interrupted');
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') downloadNOC();
    };

    return (
        <div className="container">
            <div className="utr_navbar">
                <button className='button back_button' onClick={() => history.goBack()}>
                    <img src={require("../assets/images/back.png")} alt="back" />
                </button>
                <h3>Download Loan NOC</h3>
                <button className='button' onClick={logout}>
                    <img src={require("../assets/images/power-off.png")} alt="logout" />
                </button>
            </div>

            <div className="mt-4 d-flex justify-content-center">
                <div className="row" style={{ width: '100%', maxWidth: '800px' }}>
                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <label htmlFor="loanId" style={{ fontWeight: 'bold' }}>Loan ID(s)</label>
                        {validationError && (
                            <div className="invalid-feedback" style={{ display: 'block' }}>
                                {validationError}
                            </div>
                        )}
                        <input
                            id="loanId"
                            type="text"
                            className={`form-control ${validationError ? 'is-invalid' : ''}`}
                            value={loanIdsInput}
                            onChange={handleInputChange}
                            onKeyPress={handleKeyPress}
                            placeholder="Enter Loan ID(s) separated by commas (max 10)"
                            disabled={loading}
                        />
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-end">
                        <button
                            className="btn btn-primary w-100"
                            onClick={downloadNOC}
                            disabled={loading || !loanIdsInput.trim()}
                        >
                            {loading && (
                                <span
                                    className="spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                />
                            )}
                            {loading ? 'Downloading...' : 'Download NOC(s)'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoanNocDownload;
